import React from "react";
import { SimpleShowLayout } from "react-admin";
import SessionExamSlotDate from "./SessionExamSlotDate";
import { SectionTitle } from "features/SectionTitle";

const SessionExamSlots = ({ record }) => {
  return (
    <>
      <SectionTitle
        title="Време и място на провеждане"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        {record && (
          <SessionExamSlotDate
            slot={record.slot}
            academicSessionId={record.academicSessionId}
          />
        )}
      </SimpleShowLayout>
    </>
  );
};

export default SessionExamSlots;
